import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';

@Injectable({
  providedIn: 'root',
})
export class BugReportService {
  public takeSnapshot(htmlEle: HTMLElement): Promise<string> {
    return new Promise((resolve, reject) => {
      html2canvas(htmlEle, {
        allowTaint: true,
        useCORS: true,
        logging: false,
        // foreignObjectRendering: true,
      })
        .then((canvas) => {
          const imageUrl = canvas.toDataURL('image/jpeg', 0.5);
          resolve(imageUrl);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
